import axios from 'axios'

export function getMenuList(id) {
  return axios({
    url: '/sys/menu/getUserMenu',
    method: 'post',
    data: {
      parentId: id
    }
  })
}

export function getMenuTree({
  lazy=false,
  parentId=-1
}) {
  return axios({
    url: '/sys/menu/tree',
    method: 'post',
    data: {
      lazy,
      parentId
    }
  })
}

export function getRoleMenu(roleId) {
  return axios({
    url: '/sys/menu/getRoleTree',
    method: 'post',
    data: {
      roleId
    }
  })
}

export function delMenu(id) {
  return axios({
    url: '/sys/menu/removeById',
    method: 'post',
    data: {
      id
    }
  })
}

export function addMenu(obj) {
  return axios({
    url: '/sys/menu/save',
    method: 'post',
    data: obj
  })
}

export function getMenuDetail(id) {
  return axios({
    url: '/sys/menu/detail',
    method: 'post',
    data: {
      id
    }
  })
}
export function updateMenu(obj) {
  return axios({
    url: '/sys/menu/update',
    method: 'post',
    data: obj
  })
}



// WEBPACK FOOTER //
// ./src/api/admin/menu.js